import useApiQueryData from "../use_api_query_data";
import { API_CLIENTS_BACKEND } from "../../api";
import XNGApiQueryParamObject from "../../../types/xng_api_query_param_object";

type Data = Awaited<ReturnType<typeof API_CLIENTS_BACKEND.getClients>>;
type QueryParams = {
  /** Two-letter abbreviation. Undefined until the user picks a state; the query stays disabled. */
  state: string | undefined;
};

/**
 * Accounts in a state — step two of the registration cascade. Deliberately takes no client id: the
 * caller is mid-onboarding and is looking for the account they should belong to.
 */
const useApiQueryGetClientsByState = (
  paramObject: XNGApiQueryParamObject<QueryParams, Data>,
) => {
  const { state } = paramObject.queryParams;

  return useApiQueryData({
    queryFn: async () => await API_CLIENTS_BACKEND.getClients({ state: state! }),
    queryKey: ["getClients", state],
    enabled: Boolean(state),
    staleTime: 1000 * 60 * 5,
    ...(paramObject.options ?? {}),
  });
};

export default useApiQueryGetClientsByState;
